import React from 'react';
import { useSelector } from 'react-redux';
import { selectDynamicCardIsOngoingLinking } from 'core/modules/Instore2/selectors';
import Loader from 'core/modules/Partials/Loader/Loader';
import LinkButton from './components/LinkButton';

function InstoreOfferLink({ offer, namespace }) {
  const { offerId } = offer;
  const isOngoingLinking = useSelector(state => selectDynamicCardIsOngoingLinking(state, offerId));

  return (
    <div className="mn_linkOfferWrap">
      <Loader isLoading={isOngoingLinking}>
        <LinkButton offer={offer} namespace={namespace} />
      </Loader>
    </div>
  );
}

export default InstoreOfferLink;
